module.exports = __webpack_public_path__ + "static/media/shaff1171.e5169bda.jpg";